import React from "react";
import { Body } from "@common/typography/Body";

type Props = {
  legends: Array<{ color: string; legend: string }>;
  style?: React.CSSProperties;
};

export const Legend: React.FC<Props> = ({ legends, style = {} }) => (
  <div style={{ ...style, display: "inline-flex", marginTop: 8 }}>
    {legends.map((l) => (
      <div style={{ display: "flex", marginRight: 8 }} key={l.legend}>
        <div
          style={{
            width: 17,
            height: 17,
            backgroundColor: l.color,
            display: "inline-block",
            marginRight: 4,
            borderRadius: 4
          }}
        />
        <Body variant="caption">{l.legend}</Body>
      </div>
    ))}
  </div>
);
